import {PermissionCheck} from "../../../../../components/Access/helper/permission/PermissionCheck";

export function getTransactionInitStatus(type) {
    const draftOnly = PermissionCheck.withTransactionType(type).hasSomeModifier(['M3']);
    const requireApproval = PermissionCheck.withTransactionType(type).hasSomeModifier(['M4']);

    if (requireApproval)
        return 'pending_approval';

    if (draftOnly)
        return 'draft';

    return 'ready';
}
